import { accountDeleteApi } from "../../api/account/accountDeleteApi"

type PayloadShape = Parameters<typeof accountDeleteApi>[0]

export async function accountDeleteService(payload: PayloadShape, token: string) {
	return await accountDeleteApi(payload, token)
}
